import { createEffect, createEvent, sample } from "effector";
import { audio } from "frontend/src/domain/audio";
export var audioCurrentTimeChanged = createEvent();
var audioCurrentTimeChangedFx = createEffect(function (time) { return (audio.currentTime = time); });
sample({
    clock: audioCurrentTimeChanged,
    target: audioCurrentTimeChangedFx,
});
